import { checkNavigation } from './service.js';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["ADD_ROUTE"] = "ADD_ROUTE";
    ActionTypes["NAVIGATE"] = "NAVIGATE";
    ActionTypes["SET_ACTIVE_ROUTE"] = "SET_ACTIVE_ROUTE";
})(ActionTypes || (ActionTypes = {}));
export const addRoute = (path) => ({
    type: ActionTypes.ADD_ROUTE,
    path,
});
export const navigate = (path) => {
    checkNavigation(path);
    return {
        type: ActionTypes.NAVIGATE,
        path,
    };
};
export const setActiveRoute = (path) => ({
    type: ActionTypes.SET_ACTIVE_ROUTE,
    path,
});
//# sourceMappingURL=actions.js.map